import $ from 'jquery';
import { revieveAddToBag } from "../../modules/revieve-try-on";

$(function() {
    $('.js-revieve-full-look').on('click', (e) => {
        e.preventDefault();
        Revieve.API.show();
        logEngagement(window.location.href, 'VTO', 'Open');
    });

    revieveAddToBag();
});


// WEBPACK FOOTER //
// ./src/scripts/entry-points/landing/index.js